import React from 'react';
import trainerImg from '../assets/images/PP Formatrice.png';

const About = () => {
  return (
    <div className="container">
      <section className="section">
        <h1 className="text-center" style={{ marginBottom: '3rem' }}>À PROPOS</h1>

        <div className="trainer-profile">
          <img src={trainerImg} alt="Cathy Gerrer" className="trainer-img" />
          <div className="trainer-bio">
            <h2>QUI SUIS-JE ?</h2>
            <h3>Cathy Gerrer – Fondatrice de HELPMIND Formation</h3>
            <span className="trainer-role">Formatrice accréditée Premiers Secours en Santé Mentale – Modules Standard & Jeunes</span>

            <p>
              Après plus de vingt ans au sein de l’Éducation nationale en tant qu’enseignante, coordinatrice de réseau et formatrice,
              j’ai accompagné de nombreux professionnels et tout autant de jeunes autour des questions d’apprentissage, de relation,
              de communication, du développement des compétences psychosociales et de la prévention du mal-être.
            </p>
            <p>
              Mon parcours m’a amenée à concevoir des formations, animer des équipes, piloter des projets éducatifs et coordonner des partenariats
              dans des contextes exigeants, notamment en Éducation prioritaire. J’ai toujours eu à cœur de créer des environnements bienveillants,
              où chacun peut trouver des repères et se sentir soutenu.
            </p>
            <p>
              Convaincue que la santé mentale doit être l’affaire de tous, j’accompagne aujourd’hui les particuliers, les équipes, les jeunes,
              les associations et les organisations.
            </p>
            <p>
              Les formations PSSM – Premiers Secours en Santé Mentale – s’appuient sur une approche humaine, structurée et profondément orientée
              vers la prévention et le mieux-être.
            </p>
          </div>
        </div>
      </section>

      <section className="section text-center">
        <h2>POURQUOI SE FORMER AUX PSSM ?</h2>
        <p style={{ fontWeight: 'bold', fontSize: '1.2rem', color: 'var(--secondary-color)', marginBottom: '30px' }}>En 2025, la santé mentale a été érigée Grande Cause Nationale</p>
        <div className="why-box">
          <ul className="why-list">
            <li>Repérer plus tôt les signes de détresse psychique et savoir agir sans s’improviser thérapeute.</li>
            <li>Développer des réflexes de premiers secours en santé mentale, utiles au quotidien.</li>
            <li>Favoriser une culture de l’écoute, de la prévention et de l’orientation adaptée.</li>
            <li>Contribuer à la qualité de vie au travail (QVCT) et au climat scolaire.</li>
          </ul>
        </div>
      </section>

      <section className="section text-center">
        <h2>NOS VALEURS</h2>
        <div className="values-box">
          <ul className="values-list-styled">
            <li><strong>Accessibilité :</strong> une formation ouverte à tous, quels que soient votre parcours et votre niveau de connaissance.</li>
            <li><strong>Solidarité :</strong> renforcement des liens et encouragement de l’entraide face aux difficultés psychologiques.</li>
            <li><strong>Prévention :</strong> intervention précoce pour limiter l’impact des troubles.</li>
            <li><strong>Reconnaissance :</strong> une formation officielle, inscrite dans un cadre institutionnel national.</li>
          </ul>
        </div>
      </section>

      <section className="section text-center">
        <h2>COMMENT ÇA MARCHE</h2>
        <div className="info-grid max-w-800">
          <div className="info-card">
            <h4>Format Standard</h4>
            <p>2 jours consécutifs ou non consécutifs (sur 2 semaines). Idéal pour une immersion complète.</p>
          </div>
          <div className="info-card">
            <h4>Format Modulaire</h4>
            <p>4 demi-journées (sur 1 mois max). Parfait pour s’adapter aux emplois du temps chargés.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
